import type { IconProps } from './IconProps';

export const BuildingIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none"
    width={props.width ?? 16}
    height={props.height ?? 16}
    {...props}
  >
    <path
      d="M4.99992 4.66667H6.83325M4.99992 7.33333H6.83325M4.99992 10H6.83325M9.16659 4.66667H10.9999M9.16659 7.33333H10.9999M9.16659 10H10.9999M13.3333 14V4.13333C13.3333 3.3866 13.3333 3.01323 13.1879 2.72801C13.0601 2.47713 12.8561 2.27316 12.6052 2.14532C12.32 2 11.9467 2 11.1999 2H4.79992C4.05318 2 3.67981 2 3.3946 2.14532C3.14372 2.27316 2.93974 2.47713 2.81191 2.72801C2.66659 3.01323 2.66659 3.3866 2.66659 4.13333V14M14.6666 14H1.33325"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
